import { glassboxWebJs } from '@prezi/client-logger-module';
let glassboxLoggerOverride = undefined;
export const getGlassboxLogger = () => glassboxLoggerOverride ?? glassboxWebJs;
export const setGlassboxLoggerOverride = logger => {
  glassboxLoggerOverride = logger;
};